import { Button } from "@mui/material";
import ezraLogo from "./EzraLight.png";

const REGISTRATION_URL =
  "https://bethelbibleoc.churchcenter.com/registrations/events/3509171";

const DAY_ONE = { label: "Friday", date: "October 2", time: "8:30 AM" };
const DAY_TWO = { label: "Saturday", date: "October 3", time: "6:00 PM" };

const Ezra = () => {
  return (
    <>
      <style>{`
        .ezra-page {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          min-height: 100vh;
          padding: clamp(48px, 8vw, 96px) 24px 72px;
          background: radial-gradient(ellipse at top, #1a2f57 0%, #0f1c38 70%);
          color: #F3EEE1;
          box-sizing: border-box;
        }

        .ezra-crest {
          width: min(280px, 60vw);
          height: auto;
          margin-bottom: 22px;
        }

        .ezra-sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .ezra-eyebrow {
          font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.28em;
          text-transform: uppercase;
          color: #B4914B;
          margin: 0 0 24px;
        }

        .ezra-eyebrow-emphasis {
          color: #F3EEE1;
        }

        .ezra-cta-wrap {
          margin: 0 0 40px;
        }

        .ezra-cta {
          font-family: "Inter", sans-serif !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          letter-spacing: 0.16em !important;
          text-transform: uppercase !important;
          color: #F3EEE1 !important;
          border: 1px solid #B4914B !important;
          border-radius: 2px !important;
          padding: 14px 34px !important;
          transition: background-color 0.25s ease, color 0.25s ease !important;
        }

        .ezra-cta:hover {
          background-color: #B4914B !important;
          color: #0f1c38 !important;
        }

        .ezra-rule {
          width: 120px;
          height: auto;
          margin: 0 0 26px;
          color: #B4914B;
        }

        .ezra-verse {
          font-family: "Cormorant Garamond", "Georgia", serif;
          font-style: italic;
          font-weight: 500;
          font-size: clamp(19px, 3.4vw, 27px);
          line-height: 1.5;
          max-width: 620px;
          color: #F3EEE1;
          margin: 0 0 10px;
        }

        .ezra-verse-ref {
          font-family: "Inter", sans-serif;
          font-size: 13px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #8FA3C9;
          margin: 0 0 48px;
        }

        .ezra-dates-card {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(20px, 4vw, 48px);
          padding: 28px clamp(24px, 5vw, 56px);
          border-top: 1px solid rgba(180, 145, 75, 0.5);
          border-bottom: 1px solid rgba(180, 145, 75, 0.5);
        }

        .ezra-date-col {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
        }

        .ezra-date-day {
          font-family: "Inter", sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.24em;
          text-transform: uppercase;
          color: #B4914B;
          margin: 0;
        }

        .ezra-date-date {
          font-family: "Cormorant Garamond", "Georgia", serif;
          font-weight: 600;
          font-size: clamp(24px, 4vw, 30px);
          color: #F3EEE1;
          margin: 0;
        }

        .ezra-date-time {
          font-family: "Inter", sans-serif;
          font-size: 13px;
          letter-spacing: 0.04em;
          color: #8FA3C9;
          margin: 0;
        }

        .ezra-date-arrow {
          width: 28px;
          height: auto;
          color: #B4914B;
          flex-shrink: 0;
        }

        @media (prefers-reduced-motion: no-preference) {
          .ezra-crest, .ezra-eyebrow, .ezra-cta-wrap, .ezra-rule,
          .ezra-verse, .ezra-verse-ref, .ezra-dates-card {
            animation: ezra-rise 0.7s ease both;
          }
          .ezra-eyebrow { animation-delay: 0.1s; }
          .ezra-cta-wrap { animation-delay: 0.18s; }
          .ezra-rule { animation-delay: 0.26s; }
          .ezra-verse { animation-delay: 0.32s; }
          .ezra-verse-ref { animation-delay: 0.4s; }
          .ezra-dates-card { animation-delay: 0.48s; }
        }

        @keyframes ezra-rise {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 480px) {
          .ezra-page { padding-top: 40px; }
          .ezra-crest { width: 70vw; margin-bottom: 18px; }
          .ezra-dates-card { padding: 22px 20px; gap: 16px; }
          .ezra-date-arrow { width: 20px; }
        }
      `}</style>

      <main className="ezra-page">
        <h1 className="ezra-sr-only">The Ezra Conference</h1>

        <img
          src={ezraLogo}
          className="ezra-crest"
          alt="The Ezra Conference crest, Study Live Teach, established 2024"
        />

        <p className="ezra-eyebrow">
          3rd Annual <span className="ezra-eyebrow-emphasis">Conference for Men</span>
        </p>

        <div className="ezra-cta-wrap">
          <a
            href={REGISTRATION_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="outlined" size="large" className="ezra-cta">
              Register for the Conference
            </Button>
          </a>
        </div>

        <svg
          className="ezra-rule"
          viewBox="0 0 120 14"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M0 7 H45 M75 7 H120"
            stroke="currentColor"
            strokeWidth="1"
          />
          <path
            d="M60 2 C56 5 56 9 60 12 C64 9 64 5 60 2 Z"
            fill="currentColor"
          />
        </svg>

        <p className="ezra-verse">
          For Ezra had set his heart to study the Law of the LORD, and to
          do it and to teach his statutes and rules in Israel.
        </p>
        <p className="ezra-verse-ref">Ezra 7:10</p>

        <div className="ezra-dates-card">
          <div className="ezra-date-col">
            <p className="ezra-date-day">{DAY_ONE.label}</p>
            <p className="ezra-date-date">{DAY_ONE.date}</p>
            <p className="ezra-date-time">{DAY_ONE.time}</p>
          </div>

          <svg
            className="ezra-date-arrow"
            viewBox="0 0 28 10"
            fill="none"
            aria-hidden="true"
          >
            <path d="M0 5 H24" stroke="currentColor" strokeWidth="1" />
            <path d="M19 1 L24 5 L19 9" stroke="currentColor" strokeWidth="1" fill="none" />
          </svg>

          <div className="ezra-date-col">
            <p className="ezra-date-day">{DAY_TWO.label}</p>
            <p className="ezra-date-date">{DAY_TWO.date}</p>
            <p className="ezra-date-time">{DAY_TWO.time}</p>
          </div>
        </div>
      </main>
    </>
  );
};

export default Ezra;
